import * as React from 'react';
import {Provider} from 'react-redux';
import configureStore from "./configureStore";
import {rootReducer} from "./store/reducers";
import {IApplicationState} from "./store/types";

import { UIRouter, UIView } from '@uirouter/react';
import Dialog from '../global/components/Dialog';

// import routing
import {router} from '../router.config';

// @ts-ignore
const initialState = rootReducer({} as IApplicationState,{type: '@@INIT'});
const store = configureStore(initialState);


export const App = () => {
    return (
        <UIRouter router={router}>
            <Provider store={store}>
                <React.StrictMode>
                    <UIView/>
                    <Dialog/>
                </React.StrictMode>
            </Provider>
        </UIRouter>
    );
};
